/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Credit_Notes_To_SendInputs */

const en_queue_credit_notes_to_send = /** @type {(inputs: Queue_Credit_Notes_To_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit notes to send`)
};

/**
* | output |
* | --- |
* | "Credit notes to send" |
*
* @param {Queue_Credit_Notes_To_SendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_credit_notes_to_send = /** @type {((inputs?: Queue_Credit_Notes_To_SendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Credit_Notes_To_SendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_credit_notes_to_send(inputs)
});